import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Sidebar from "./Sidebar";
import {
  Switch,
  Route,
  useHistory,
  withRouter,
  useLocation,
} from "react-router-dom";
import KYCBanner from "../CommonPage/KYCBanner";
import { userActions } from "../../redux/actions/user.actions";
import "./LandingPage.style.scss";
import { TimeoutLogic } from "../../timeoutComponent/TimeoutLogic";
import Cookies from "universal-cookie";
import CommonSearch from "../CommonPage/CommonSearch.component";

import CompanyMenuDetailsComponent from "../CompanyMenuComponent/CompanyMenuDetails.Component";
import CompaniesLandingComponent from "../CompaniesComponents/CompaniesLanding.component";
import ASICDeptLandingComponent from "../ASICDeptComponents/ASICDeptLanding.Component";
import BusinessNameLanding from "../BusinessNameComponent/BusinessNamelanding.component";
import BenificialOwnerLanding from "../BeneficialOwnerComponent/BeneficialOwnerLanding.component";
import EOrderOrderRequestLanding from "../ChangesAndOrderRequest/EorderOrderRequestLanding.Component";
import DIDListComponentLanding from "../DIDListComponent/DIDListComponentLanding";
import DigitalSignatureLanding from "../DigitalSignatureComponent/DigitalSignatureLandingComponent";
import EbinderMainLanding from "../EbinderMainLandingComponent/EbinderMainLandingComponent";
import FormsAndDocumentsLanding from "../FormsandDocumentsComponent/formsAndDocumentsLanding.Component";
import IndividualEntitiesLandingComponent from "../Individual&EntitiesComponents/IndividualEntitiesLanding.component";
import JointHolderLandingComponent from "../JointHoldersComponents/JointHolderLanding.component";
import MonitorLanding from "../MonitorsComponents/MonitorLanding.Component";
import OrderMonitorLanding from "../OrderMonitorComponents/OrderMonitorLanding.Component";
import ProfileSettingLanding from "../ProfileSettingComponent/ProfileSettingLanding";
import UnitTrustRegisterLanding from "../UnitTrustRegisterComponent/UnitTrustRegisterLanding";

const LandingPage = (props) => {
  const [isMobile] = useState(document.body.clientWidth <= 498);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const noSearch = ["/EorderOrderRequestLanding"].includes(pathname);
  useEffect(() => {
    dispatch(userActions.getLoggedUserInfo());
    dispatch(userActions.getDirectorIdCount());
    // eslint-disable-next-line
  }, [isMobile]);
  console.log("isMobile --------", isMobile);
  //message card

  const cookies = new Cookies();
  const history = useHistory();

  useEffect(() => {
    const token = cookies.get("token");

    if (!token) {
      dispatch(userActions.logout());
      history.push("/login");
    }
  });

  return (
    <div className="container-fluid p-0">
      <TimeoutLogic history={props.history} />
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed((prev) => !prev)}
      />
      <div
        className="mainContent overflow-auto vh-100"
        style={{
          marginLeft: sidebarCollapsed ? "64px" : "240px",
          transition: "margin-left 250ms ease",
        }}
      >
          {["/","/CompanyMenuDetails"].includes(pathname) && (
            <div className='banner'>
              <KYCBanner />
            </div>
          )}
          <div className="py-3">
            {!noSearch && <CommonSearch {...props} />}
            {<hr />}
            <div className="row">
              <span className="lead">
                <Switch>
                  <Route path="/CompaniesLanding">
                    <CompaniesLandingComponent {...props} />
                  </Route>
                  <Route path="/ASICDeptLanding">
                    <ASICDeptLandingComponent />
                  </Route>
                  <Route path="/BusinessNameLanding">
                    <BusinessNameLanding />
                  </Route>
                  <Route path="/BeneficialOwnerLanding">
                    <BenificialOwnerLanding />
                  </Route>
                  <Route path="/EorderOrderRequestLanding">
                    <EOrderOrderRequestLanding {...props} />
                  </Route>
                  <Route path="/DIDListLanding">
                    <DIDListComponentLanding />
                  </Route>
                  <Route path="/DigitalSignatureLanding">
                    <DigitalSignatureLanding />
                  </Route>
                  <Route path="/EbinderMainLanding">
                    <EbinderMainLanding {...props} />
                  </Route>
                  <Route path="/FormsAndDocumentsLanding">
                    <FormsAndDocumentsLanding />
                  </Route>
                  <Route path="/IndividualEntitiesLanding">
                    <IndividualEntitiesLandingComponent />
                  </Route>
                  <Route path="/jointHolderLanding">
                    <JointHolderLandingComponent />
                  </Route>
                  <Route path="/MonitorLanding">
                    <MonitorLanding {...props} />
                  </Route>
                  <Route path="/OrderMonitorLanding">
                    <OrderMonitorLanding />
                  </Route>
                  <Route path="/ProfileSettings">
                    <ProfileSettingLanding />
                  </Route>
                  <Route path="/UnitTrustRegisterLanding">
                    <UnitTrustRegisterLanding />
                  </Route>
                  <Route path={["/","/CompanyMenuDetails"]} >
                    <CompanyMenuDetailsComponent {...props} />
                  </Route>
                </Switch>
              </span>
            </div>
          </div>
        </div>
      </div>
  );
};
export default withRouter(LandingPage);
